import React from "react";
import Button from "@overrides_venia/venia-ui/components/Button";
import Modal from "@Components/Modal";
import { useIntl } from "react-intl";
import { useHistory } from "@Src_main/drivers";
import { removeBasenameFromPath } from "@Src_main/utils/generalUtils";
export var ModalCompleteCustomerData = _ref => {
  var {
    isOpen,
    setIsOpen
  } = _ref;
  var {
    formatMessage
  } = useIntl();
  var history = useHistory();
  var onClickFunction = () => {
    setIsOpen(false);
    var returnUrl = removeBasenameFromPath(window.location.pathname, "/it");
    var url = "".concat(formatMessage({
      id: "url.key.loyalty.data"
    }), "?returnUrl=").concat(returnUrl);
    history.push(url);
  };
  return /*#__PURE__*/React.createElement(Modal, {
    id: "modal-complete-data-selection",
    modalCloseOutside: true,
    modalDialogClass: "uk-border-rounded uk-position-center uk-padding ",
    animation: "uk-animation-scale-up",
    isOpen: isOpen,
    onClose: onClickFunction,
    canBeClosed: false
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h1", {
    className: "uk-margin-small-bottom uk-text-center uk-text-uppercase uk-text-small"
  }, formatMessage({
    id: "modal.customer.complete.data.title"
  })), /*#__PURE__*/React.createElement("div", {
    className: "uk-margin-small-bottom uk-flex uk-flex-around uk-flex-wrap uk-text-small uk-text-center"
  }, formatMessage({
    id: "modal.customer.complete.data.text"
  })), /*#__PURE__*/React.createElement(Button, {
    id: "favStoreSetter",
    onClick: onClickFunction,
    color: "miscusi_red",
    type: "button",
    height: "small",
    fullScreen: true,
    extraClass: "uk-align-center"
  }, formatMessage({
    id: "button.confirm"
  }))));
};